import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import esMX from "./locales/es-MX.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import zh from "./locales/zh.json";
import hi from "./locales/hi.json";
import ar from "./locales/ar.json";
import ja from "./locales/ja.json";
import de from "./locales/de.json";
import id from "./locales/id.json";

const LOCALE_CONFIG = {
  en: { data: en },
  es: { data: es },
  "es-MX": { data: esMX },
  fr: { data: fr },
  pt: { data: pt },
  zh: { data: zh },
  hi: { data: hi },
  ar: { data: ar },
  ja: { data: ja },
  de: { data: de },
  id: { data: id }
};

const SUPPORTED_LOCALES = Object.keys(LOCALE_CONFIG);
const RTL_LOCALES = ["ar"];
const DEFAULT_LOCALE = "en";

function getCookie(name) {
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

function getLocaleFromCookie() {
  const cookieLocale = getCookie("locale");
  const supportedLocales = ["en", "es", "es-MX", "fr", "pt", "zh", "hi", "ar", "ja", "de", "id"];
  if (cookieLocale && supportedLocales.includes(cookieLocale)) {
    return cookieLocale;
  }
  return "en";
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en.en },
      es: { translation: es.es },
      "es-MX": { translation: esMX["es-MX"] },
      fr: { translation: fr.fr },
      pt: { translation: pt.pt },
      zh: { translation: zh.zh },
      hi: { translation: hi.hi },
      ar: { translation: ar.ar },
      ja: { translation: ja.ja },
      de: { translation: de.de },
      id: { translation: id.id }
    },
    lng: getLocaleFromCookie(),
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;
